module.exports = require("babel-runtime/core-js/object/create");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/object/create"
// module id = 78
// module chunks = 0